import { useState, useEffect } from 'react';
import classNames from 'classnames/bind';

import RoundRadioButton from '../../../GeneralComponents/RoundRadioButton';
import SourcesSelection from './SourcesSelection';
import UpgradeTooltipSmall from '../../../GeneralComponents/UpgradeTooltip/UpgradeTooltipSmall';

import { sourcesValues } from '../../../../data/filters/storyFilters';
import { CONTENT_SOURCE_FILTER } from '../../../../data/features';

import useSizes from '../../../../hooks/sizes';

import withComponentName from '../../../../decorators/withComponentName';

import Styles from '../../story-filters-styles.module.scss';

const cx = classNames.bind(Styles);

const ManageSources = ({
  features, domainFilteringMode, setDomainsInfo, setSelectedDomains,
}) => {
  const [sourceCategory, setSourceValue] = useState('all');
  const { width } = useSizes();

  useEffect(() => {
    setSourceValue(domainFilteringMode);
  }, []);

  useEffect(() => {
    setDomainsInfo(sourceCategory);
  }, [sourceCategory]);

  const domainsSelectionFeature = features.includes(CONTENT_SOURCE_FILTER);

  return (
    <div className={Styles['manage-sources-wrapper']}>
      <div className={Styles['manage-sources-buttons-wrapper']}>
        {sourcesValues.map(({
          title, id, key, mobileTitle,
        }) => (
          <div
            className={cx('round-button-wrapper--inner')}
            key={id}
          >
            {!domainsSelectionFeature && key !== 'all' && (
              <UpgradeTooltipSmall
                planBadgeText="Silver"
                cssClass="upgrade-source-badge"
              />
            )}
            <RoundRadioButton
              key={id}
              value={key}
              name={width <= 767 ? mobileTitle : title}
              selectedFilterValue={sourceCategory}
              setValue={setSourceValue}
              filterItemInfo={key}
              customClass="sources-radio-btn"
              buttonDisabled={!domainsSelectionFeature && key !== 'all'}
            />
          </div>
        ))}
      </div>
      <SourcesSelection
        sourceCategory={sourceCategory}
        domainsSelectionFeature={domainsSelectionFeature}
        setDomainsInfo={setDomainsInfo}
        setSelectedDomains={setSelectedDomains}
        domainFilteringMode={domainFilteringMode}
      />
    </div>
  );
};

export default withComponentName(ManageSources);
